<template>
<m-pageframe
    :title="savepoint?.label || 'Loading...'"
>
<v-container
    fluid
>
    <link-back
        text="All Bulk Contact Changes"
        :to="{
            name: 'search-bulk-contact-changes',
            params: { organization_id: $route.params.organization_id }
        }"
    />

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item @click="startRollback('rollback')">
                    <v-list-item-title>Reverse changes...</v-list-item-title>
                </v-list-item>

                <v-list-item @click="startRollback('reapply')">
                    <v-list-item-title>Re-apply changes...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :loading="loading_entries"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
         <template v-slot:item.time_date="{ item }">
            {{$rc.pretty(item.time,'date')}}
        </template>

        <template v-slot:item.time_time="{ item }">
            {{$rc.pretty(item.time,'time')}}
        </template>

        <template v-slot:item.before_label="{ item }">
            <span v-html="labelHtml(item.before_label, item.current_label)"/>
        </template>

         <template v-slot:item.after_label="{ item }">
            <span v-html="labelHtml(item.after_label, item.current_label)"/>
         </template>

         <template v-slot:item.current_label="{ item }">
            <span v-html="labelHtml(item.current_label, item.current_label)"/>
         </template>

         <template v-slot:item.before_endpoints="{ item }">
            <span v-html="endpointsHtml(item.before_endpoints, item.current_endpoints)"/>
         </template>

          <template v-slot:item.after_endpoints="{ item }">
            <span v-html="endpointsHtml(item.after_endpoints, item.current_endpoints)"/>
         </template>

         <template v-slot:item.current_endpoints="{ item }">
            <span v-html="endpointsHtml(item.current_endpoints, item.current_endpoints)"/>
         </template>

    </v-data-table>
    
    <br/>
    <b>Bold values</b> indicate that the value is current.

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
import SavepointMixin from '@/mixins/imports/savepoint.js';

export default {
    mixins: [SavepointMixin],

    data() {
        return {
            full_text: null,
            savepoint: null,
            loading_entries: false,
            results: [],

            headers: [
                { text: 'Date', value: 'time_date'},
                { text: 'Date', value: 'time_time'},

                { text: 'Label (before)', value: 'before_label'},
                { text: 'Label (after)', value: 'after_label'},
                { text: 'Label (current)', value: 'current_label'},

                { text: 'Numbers (before)', value: 'before_endpoints'},
                { text: 'Numbers (after)', value: 'after_endpoints'},
                { text: 'Numbers (current)', value: 'current_endpoints'},
            ],
        }
    },

    mounted () {
        this.loadSavepoint();
        this.doUpdate()
    },

    methods: {
        loadSavepoint() {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/contacts/savepoint',
            
                'params' : {
                        'savepoint_id': this.$route.params.savepoint_id,
                    },
            
                'on_success': (data) => {
                        this.savepoint = data.results[0];
                    },
            
                'on_error': 'Unable to get savepoint',
            });
        },

        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.loading_entries = true;

            this.$rc.rest({
                spinner: false,
                endpoint: 'LIST: /api/v1/contacts/savepoint/entries',
            
                params : {
                    savepoint_id: this.$route.params.savepoint_id,
                    full_text: this.full_text,
                },
            
                on_success: (data) => {
                    this.loading_entries = false;
                    this.results = data.results;
                },
            
                on_error: (error) => {
                    this.loading_entries = false;
                    this.$rc.alert('Error', 'Unable to search contact changes');
                },
            });
        },

        labelHtml(value, current)
        {
            let label = value;
            if ( label == null ) label = '<i>none</i>';

            if ( value == current )
            {
                label = '<b>'+label+'</b>';
            }

            return label;
        },

        endpointsHtml(value, current)
        {
            if ( value == null || value.length == 0 )
            {
                let label = '<i>none</i>';
                
                if ( current == null )
                {
                    label = '<b>'+label+'</b>';
                }

                return label;
            }
            else
            {
                let label = this.$rc.pretty(value, 'endpoints');

                if ( _.isEqual(value,current) )
                {
                    label = '<b>'+label+'</b>';
                }

                return label;
            }
        },

        startRollback(direction)
        {
            this.onClickStartRollback(
                this.$route.params.savepoint_id,
                direction,
                () => { this.doUpdate(); }
            );
        },
    
    },
}
</script>

<style lang="scss" scoped>
</style>